const RESERVED = new Set(["api", "app", "admin", "www", "portal", "support", "auth"]);

export function validateSubdomain(subdomain) {
  if (!subdomain) return { ok: false, reason: "missing" };
  if (!/^[a-z0-9-]{3,63}$/.test(subdomain)) return { ok: false, reason: "invalid_format" };
  if (RESERVED.has(subdomain)) return { ok: false, reason: "reserved" };
  return { ok: true };
}
